// Generated from backend shop-block-localization.json. Do not edit manually.

export const SHOP_BLOCK_LOCALIZATION_SCHEMA_VERSION = 3;

export const SHOP_BLOCK_LOCALIZATION_SCHEMA_DATA = /** @type {const} */ ({
    "text": [
        {
            "defaultMessageKey": "block.text.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "paragraph": [
        {
            "defaultMessageKey": "block.paragraph.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "heading": [
        {
            "defaultMessageKey": "block.heading.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.heading.title",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "quote": [
        {
            "defaultMessageKey": "block.quote.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.author",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "code": [
        {
            "defaultMessageKey": "block.code.code",
            "fieldCode": "content.code",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.language",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "list": [
        {
            "defaultMessageKey": "block.list.items",
            "fieldCode": "content.items",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.style",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "checklist": [
        {
            "defaultMessageKey": "block.checklist.items",
            "fieldCode": "content.items",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "button": [
        {
            "defaultMessageKey": "block.button.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "link": [
        {
            "defaultMessageKey": "block.link.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "image": [
        {
            "fieldCode": "content.alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.mediaUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.src",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "media": [
        {
            "fieldCode": "content.alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.src",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.mediaUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.fileUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "video": [
        {
            "fieldCode": "content.alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.videoUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.posterUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.mediaUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "uploadFile": [
        {
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.file",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.fileUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.mediaUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "table": [
        {
            "fieldCode": "content.items",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "card": [
        {
            "defaultMessageKey": "block.card.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.card.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.src",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "column": [],
    "columns": [],
    "accordion": [
        {
            "defaultMessageKey": "block.accordion.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.accordion.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "accordionItem": [
        {
            "defaultMessageKey": "block.accordionItem.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.accordionItem.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "separator": [],
    "icon": [
        {
            "defaultMessageKey": "block.icon.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.icon",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "emoji": [
        {
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "signature": [
        {
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "alert": [
        {
            "defaultMessageKey": "block.alert.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "rating": [
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.ratingValue",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.ratingMax",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "socialMedia": [
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.socialLinks",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "socialLink": [
        {
            "defaultMessageKey": "block.socialLink.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.icon",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "share": [
        {
            "defaultMessageKey": "block.share.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "textHighlight": [
        {
            "defaultMessageKey": "block.textHighlight.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.textHighlight.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "chart": [
        {
            "defaultMessageKey": "block.chart.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.chart.chartRows",
            "fieldCode": "content.chartRows",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.chart.chartSeries",
            "fieldCode": "content.chartSeries",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        }
    ],
    "progressBar": [
        {
            "defaultMessageKey": "block.progressBar.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.progressValue",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "badge": [
        {
            "defaultMessageKey": "block.badge.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "ctaBadge": [
        {
            "defaultMessageKey": "block.ctaBadge.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.ctaBadge.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "field": [
        {
            "defaultMessageKey": "block.field.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.description",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.choices",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.placeholder",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.defaultValue",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        }
    ],
    "form": [
        {
            "fieldCode": "content.successMessage",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.actionUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.successUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "submitButton": [
        {
            "defaultMessageKey": "block.submitButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "blockquote": [
        {
            "defaultMessageKey": "block.blockquote.author",
            "fieldCode": "content.author",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.blockquote.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "searchBar": [
        {
            "defaultMessageKey": "block.searchBar.placeholder",
            "fieldCode": "content.placeholder",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.searchBar.buttonLabel",
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "input": [
        {
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.input.placeholder",
            "fieldCode": "content.placeholder",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.name",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "textarea": [
        {
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.textarea.placeholder",
            "fieldCode": "content.placeholder",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.name",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "iconList": [
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.iconList.items",
            "fieldCode": "content.items",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.icon",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "iconText": [
        {
            "defaultMessageKey": "block.iconText.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.icon",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "countdown": [
        {
            "defaultMessageKey": "block.countdown.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.targetDate",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "facebook": [
        {
            "defaultMessageKey": "block.facebook.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "instagram": [
        {
            "defaultMessageKey": "block.instagram.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "map": [
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.address",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.mapUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.latitude",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.longitude",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "avatars": [
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.items",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        }
    ],
    "appointmentButton": [
        {
            "defaultMessageKey": "block.appointmentButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "donationButton": [
        {
            "defaultMessageKey": "block.donationButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "addToCartButton": [
        {
            "defaultMessageKey": "block.addToCartButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "supportedPaymentButton": [
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.supportedPaymentButton.items",
            "fieldCode": "content.items",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        }
    ],
    "product": [
        {
            "defaultMessageKey": "block.product.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.product.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.addToCartButton.label",
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.productUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.price",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "introHero": [
        {
            "defaultMessageKey": "block.introHero.badge",
            "fieldCode": "content.badge",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.introHero.primaryLabel",
            "fieldCode": "content.primaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.secondaryLabel",
            "fieldCode": "content.secondaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.primaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.secondaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.imageAlt",
            "fieldCode": "content.imageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.image2Alt",
            "fieldCode": "content.image2Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.image3Alt",
            "fieldCode": "content.image3Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.videoUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.stat1Label",
            "fieldCode": "content.stat1Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat1Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.stat1Value",
            "fieldCode": "content.stat1Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.stat2Label",
            "fieldCode": "content.stat2Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat2Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.stat2Value",
            "fieldCode": "content.stat2Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.stat3Label",
            "fieldCode": "content.stat3Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat3Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.stat3Value",
            "fieldCode": "content.stat3Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat4Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat4Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat4Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.feature1Title",
            "fieldCode": "content.feature1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.feature1Text",
            "fieldCode": "content.feature1Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.feature2Title",
            "fieldCode": "content.feature2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.feature2Text",
            "fieldCode": "content.feature2Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.feature3Title",
            "fieldCode": "content.feature3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.feature3Text",
            "fieldCode": "content.feature3Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.glass1Title",
            "fieldCode": "content.glass1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.glass1Text",
            "fieldCode": "content.glass1Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.glass2Title",
            "fieldCode": "content.glass2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.glass2Text",
            "fieldCode": "content.glass2Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.glass3Title",
            "fieldCode": "content.glass3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.glass3Text",
            "fieldCode": "content.glass3Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.trust1Label",
            "fieldCode": "content.trust1Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.trust2Label",
            "fieldCode": "content.trust2Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.introHero.trust3Label",
            "fieldCode": "content.trust3Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "columnsShowcase": [
        {
            "fieldCode": "content.badge",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.columnsShowcase.primaryLabel",
            "fieldCode": "content.primaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.secondaryLabel",
            "fieldCode": "content.secondaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.primaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.secondaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.imageAlt",
            "fieldCode": "content.imageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.image2Alt",
            "fieldCode": "content.image2Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.image3Alt",
            "fieldCode": "content.image3Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.videoUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat1Label",
            "fieldCode": "content.stat1Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat1Text",
            "fieldCode": "content.stat1Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat1Value",
            "fieldCode": "content.stat1Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat2Label",
            "fieldCode": "content.stat2Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat2Text",
            "fieldCode": "content.stat2Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat2Value",
            "fieldCode": "content.stat2Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat3Label",
            "fieldCode": "content.stat3Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat3Text",
            "fieldCode": "content.stat3Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.stat3Value",
            "fieldCode": "content.stat3Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat4Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat4Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.stat4Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card1Title",
            "fieldCode": "content.card1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card1Text",
            "fieldCode": "content.card1Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card1Label",
            "fieldCode": "content.card1Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card1ImageAlt",
            "fieldCode": "content.card1ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card1ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card1Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card1ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card2Title",
            "fieldCode": "content.card2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card2Text",
            "fieldCode": "content.card2Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card2Label",
            "fieldCode": "content.card2Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card2ImageAlt",
            "fieldCode": "content.card2ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card2ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card2Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card2ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card3Title",
            "fieldCode": "content.card3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card3Text",
            "fieldCode": "content.card3Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card3Label",
            "fieldCode": "content.card3Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card3ImageAlt",
            "fieldCode": "content.card3ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card3ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card3Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card3ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card4Title",
            "fieldCode": "content.card4Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card4Text",
            "fieldCode": "content.card4Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card4Label",
            "fieldCode": "content.card4Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.columnsShowcase.card4ImageAlt",
            "fieldCode": "content.card4ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card4ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card4Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card4ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "contentShowcase": [
        {
            "fieldCode": "content.badge",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.contentShowcase.primaryLabel",
            "fieldCode": "content.primaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.secondaryLabel",
            "fieldCode": "content.secondaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.primaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.secondaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.imageAlt",
            "fieldCode": "content.imageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.image2Alt",
            "fieldCode": "content.image2Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.image3Alt",
            "fieldCode": "content.image3Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.videoUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat1Label",
            "fieldCode": "content.stat1Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat1Text",
            "fieldCode": "content.stat1Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat1Value",
            "fieldCode": "content.stat1Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat2Label",
            "fieldCode": "content.stat2Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat2Text",
            "fieldCode": "content.stat2Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat2Value",
            "fieldCode": "content.stat2Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat3Label",
            "fieldCode": "content.stat3Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat3Text",
            "fieldCode": "content.stat3Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat3Value",
            "fieldCode": "content.stat3Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat4Label",
            "fieldCode": "content.stat4Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat4Text",
            "fieldCode": "content.stat4Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.stat4Value",
            "fieldCode": "content.stat4Value",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card1Title",
            "fieldCode": "content.card1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card1Text",
            "fieldCode": "content.card1Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.contentShowcase.card1Label",
            "fieldCode": "content.card1Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card1ImageAlt",
            "fieldCode": "content.card1ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card1ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card1Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card1ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card2Title",
            "fieldCode": "content.card2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card2Text",
            "fieldCode": "content.card2Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.contentShowcase.card2Label",
            "fieldCode": "content.card2Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card2ImageAlt",
            "fieldCode": "content.card2ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card2ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card2Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card2ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card3Title",
            "fieldCode": "content.card3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card3Text",
            "fieldCode": "content.card3Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.contentShowcase.card3Label",
            "fieldCode": "content.card3Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card3ImageAlt",
            "fieldCode": "content.card3ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card3ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card3Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card3ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card4Title",
            "fieldCode": "content.card4Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card4Text",
            "fieldCode": "content.card4Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.contentShowcase.card4Label",
            "fieldCode": "content.card4Label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.card4ImageAlt",
            "fieldCode": "content.card4ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card4ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.card4Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.card4ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contentShowcase.code",
            "fieldCode": "content.code",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "heroSlider": [
        {
            "fieldCode": "content.slide1Eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide1Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.slide1ButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.heroSlider.slide1SecondaryButtonLabel",
            "fieldCode": "content.slide1SecondaryButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide1ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide1ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide1ButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.slide1SecondaryButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.slide1ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.slide2Eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide2Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.slide2ButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide2ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide2ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide2ButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.slide2ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.slide3Eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide3Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.slide3ButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide3ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide3ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.slide3ButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.slide3ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "categoryHero": [
        {
            "fieldCode": "content.badge",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.primaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.secondaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.primaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.secondaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.imageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Title",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image2Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.image3Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.videoUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "categoryRail": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.moreButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.moreButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category1Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category1Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category1ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category1Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category1ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category1Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category2Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category2Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category2ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category2Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category2ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category2Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category3Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category3Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category3ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category3Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category3ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category3Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category4Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category4Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category4Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category4ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category4Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category4ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category4Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category5Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category5Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category5Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category5ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category5Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category5ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category5Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category6Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category6Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category6Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category6ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category6Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category6ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category6Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category7Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category7Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category7Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category7ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category7Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category7ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category7Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category8Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category8Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.category8Discount",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category8ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.category8Url",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category8ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.category8Uuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "productRail": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.moreButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.moreButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.categoryUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.collectionUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "recentlyViewedProducts": [
        {
            "defaultMessageKey": "block.recentlyViewedProducts.eyebrow",
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.recentlyViewedProducts.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "recommendedProducts": [
        {
            "defaultMessageKey": "block.recommendedProducts.eyebrow",
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.recommendedProducts.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "relatedProducts": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "campaignGrid": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign1Eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign1Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.campaign1ButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign1ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign1ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign1ButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign1ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign2Eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign2Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.campaign2ButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign2ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign2ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign2ButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign2ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign3Eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign3Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.campaign3ButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign3ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign3ImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign3ButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.campaign3ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "brandGrid": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.brandsTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kidsEyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kidsTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.menEyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.menTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.menText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.menButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.menImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.menImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.menButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.menImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.kid1ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid1ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.kid2ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid2ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.kid3ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid3ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.kid4ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid4ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.kid5ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid5ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.kid6ImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid6ImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.kid1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.brand1Name",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.brand2Name",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.brand3Name",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid4Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.brand4Name",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid5Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.brand5Name",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.kid6Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.brand6Name",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "benefitStrip": [
        {
            "defaultMessageKey": "block.benefitStrip.eyebrow",
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.benefitStrip.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.benefitStrip.primaryLabel",
            "fieldCode": "content.primaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.benefitStrip.secondaryLabel",
            "fieldCode": "content.secondaryLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.loyaltyImageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.loyaltyImageTitle",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.benefitStrip.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.primaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.secondaryUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.loyaltyImageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "serviceBenefits": [
        {
            "defaultMessageKey": "block.serviceBenefits.benefit1Title",
            "fieldCode": "content.benefit1Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.serviceBenefits.benefit1Text",
            "fieldCode": "content.benefit1Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.serviceBenefits.benefit2Title",
            "fieldCode": "content.benefit2Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.serviceBenefits.benefit2Text",
            "fieldCode": "content.benefit2Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.serviceBenefits.benefit3Title",
            "fieldCode": "content.benefit3Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.serviceBenefits.benefit3Text",
            "fieldCode": "content.benefit3Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.serviceBenefits.benefit4Title",
            "fieldCode": "content.benefit4Title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.serviceBenefits.benefit4Text",
            "fieldCode": "content.benefit4Text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "serviceBenefitItem": [
        {
            "defaultMessageKey": "block.serviceBenefitItem.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.serviceBenefitItem.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.icon",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "newsletter": [
        {
            "defaultMessageKey": "block.newsletter.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.newsletter.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.newsletter.buttonLabel",
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.newsletter.placeholder",
            "fieldCode": "content.placeholder",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "seoText": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.moreButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.moreText1",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.moreText2",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "richContent": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "contactInfo": [
        {
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contactInfo.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.address",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.email",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.phone",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.hours",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.contactInfo.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "fieldCode": "content.mapUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.phoneText",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.emailText",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "promoBar": [
        {
            "defaultMessageKey": "block.promoBar.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.promoBar.code",
            "fieldCode": "content.code",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "header": [
        {
            "defaultMessageKey": "block.header.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "headerLogo": [
        {
            "defaultMessageKey": "block.headerLogo.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.alt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.imageUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "headerSearch": [
        {
            "defaultMessageKey": "block.headerSearch.placeholder",
            "fieldCode": "content.placeholder",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        }
    ],
    "headerStoresButton": [
        {
            "defaultMessageKey": "block.headerStoresButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "headerAccountButton": [
        {
            "defaultMessageKey": "block.headerAccountButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "headerLanguageSelector": [
        {
            "defaultMessageKey": "block.headerLanguageSelector.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "headerCurrencySelector": [
        {
            "defaultMessageKey": "block.headerCurrencySelector.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "headerFavoritesButton": [
        {
            "defaultMessageKey": "block.headerFavoritesButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "headerCartButton": [
        {
            "defaultMessageKey": "block.headerCartButton.label",
            "fieldCode": "content.label",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "headerBenefitStrip": [
        {
            "defaultMessageKey": "block.headerBenefitStrip.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.items",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        }
    ],
    "footer": [
        {
            "defaultMessageKey": "block.footer.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.footer.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        }
    ],
    "footerService": [
        {
            "defaultMessageKey": "block.footerService.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.footerService.buttonLabel",
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.footerService.email",
            "fieldCode": "content.email",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.footerService.phone",
            "fieldCode": "content.phone",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.footerService.hours",
            "fieldCode": "content.hours",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.href",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "footerLinks": [
        {
            "defaultMessageKey": "block.footerLinks.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.footerLinks.items",
            "fieldCode": "content.items",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        }
    ],
    "footerSocial": [
        {
            "defaultMessageKey": "block.footerSocial.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.socialLinks",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "footerApps": [
        {
            "defaultMessageKey": "block.footerApps.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.footerApps.items",
            "fieldCode": "content.items",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        }
    ],
    "footerCopyright": [
        {
            "defaultMessageKey": "block.footerCopyright.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.footerCopyright.items",
            "fieldCode": "content.items",
            "format": "plainText",
            "localizable": true,
            "multiline": true
        }
    ],
    "breadcrumb": [
        {
            "fieldCode": "content.homeLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.currentLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemSubcategoryList": [
        {
            "defaultMessageKey": "block.systemSubcategoryList.eyebrow",
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSubcategoryList.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSubcategoryList.emptyText",
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSubcategoryList.moreButtonLabel",
            "fieldCode": "content.moreButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.moreButtonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSubcategoryList.buttonLabel",
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSubcategoryList.category8Text",
            "fieldCode": "content.category8Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.buttonUrl",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "systemProductList": [
        {
            "defaultMessageKey": "block.systemProductList.eyebrow",
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductList.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductList.emptyText",
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductList.filterButtonLabel",
            "fieldCode": "content.filterButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductList.sortLabel",
            "fieldCode": "content.sortLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductList.resultsLabel",
            "fieldCode": "content.resultsLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemProductGallery": [
        {
            "defaultMessageKey": "block.systemProductGallery.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductGallery.imageAlt",
            "fieldCode": "content.imageAlt",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.productUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "systemProductSummary": [
        {
            "defaultMessageKey": "block.systemProductSummary.badge",
            "fieldCode": "content.badge",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductSummary.reviewButtonLabel",
            "fieldCode": "content.reviewButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductSummary.priceWithVatText",
            "fieldCode": "content.priceWithVatText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductSummary.priceWithoutVatText",
            "fieldCode": "content.priceWithoutVatText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.productUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "systemProductBuyBox": [
        {
            "defaultMessageKey": "block.systemProductBuyBox.addToCartButtonLabel",
            "fieldCode": "content.addToCartButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductBuyBox.quantityLabel",
            "fieldCode": "content.quantityLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductBuyBox.inStockText",
            "fieldCode": "content.inStockText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductBuyBox.unavailableText",
            "fieldCode": "content.unavailableText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductBuyBox.favoriteButtonLabel",
            "fieldCode": "content.favoriteButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.productUuid",
            "format": "plainText",
            "localizable": false,
            "multiline": false
        }
    ],
    "systemProductDescription": [
        {
            "defaultMessageKey": "block.systemProductDescription.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductDescription.description",
            "fieldCode": "content.description",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemProductDescription.parametersTitle",
            "fieldCode": "content.parametersTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemProductDescription.deliveryTitle",
            "fieldCode": "content.deliveryTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemCartItems": [
        {
            "defaultMessageKey": "block.systemCartItems.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.emptyText",
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.productColumnText",
            "fieldCode": "content.productColumnText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.priceColumnText",
            "fieldCode": "content.priceColumnText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.unitPriceColumnText",
            "fieldCode": "content.unitPriceColumnText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.quantityColumnText",
            "fieldCode": "content.quantityColumnText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.removeButtonLabel",
            "fieldCode": "content.removeButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.continueButtonLabel",
            "fieldCode": "content.continueButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartItems.backButtonLabel",
            "fieldCode": "content.backButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemCartSummary": [
        {
            "defaultMessageKey": "block.systemCartSummary.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.subtotalText",
            "fieldCode": "content.subtotalText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.deliveryText",
            "fieldCode": "content.deliveryText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.paymentText",
            "fieldCode": "content.paymentText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.couponTitle",
            "fieldCode": "content.couponTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.couponText",
            "fieldCode": "content.couponText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemCartSummary.totalText",
            "fieldCode": "content.totalText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.checkoutButtonLabel",
            "fieldCode": "content.checkoutButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.priceWithoutVatText",
            "fieldCode": "content.priceWithoutVatText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCartSummary.priceWithVatText",
            "fieldCode": "content.priceWithVatText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemCheckoutSteps": [
        {
            "defaultMessageKey": "block.systemCheckoutSteps.deliveryTitle",
            "fieldCode": "content.deliveryTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.deliveryText",
            "fieldCode": "content.deliveryText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.paymentTitle",
            "fieldCode": "content.paymentTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.paymentText",
            "fieldCode": "content.paymentText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.billingTitle",
            "fieldCode": "content.billingTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.billingEyebrow",
            "fieldCode": "content.billingEyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.continueButtonLabel",
            "fieldCode": "content.continueButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.backButtonLabel",
            "fieldCode": "content.backButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.submitButtonLabel",
            "fieldCode": "content.submitButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.deliveryEyebrow",
            "fieldCode": "content.deliveryEyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.deliveryFormTitle",
            "fieldCode": "content.deliveryFormTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.emailInput",
            "fieldCode": "content.emailInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.firstnameInput",
            "fieldCode": "content.firstnameInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.lastnameInput",
            "fieldCode": "content.lastnameInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.phoneInput",
            "fieldCode": "content.phoneInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.streetInput",
            "fieldCode": "content.streetInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.cityInput",
            "fieldCode": "content.cityInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.postcodeInput",
            "fieldCode": "content.postcodeInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.countryInput",
            "fieldCode": "content.countryInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.noteInput",
            "fieldCode": "content.noteInput",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.deliveryHelpText",
            "fieldCode": "content.deliveryHelpText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.billingToggleText",
            "fieldCode": "content.billingToggleText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.termsText",
            "fieldCode": "content.termsText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.completedEyebrow",
            "fieldCode": "content.completedEyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.completedTitle",
            "fieldCode": "content.completedTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.completedText",
            "fieldCode": "content.completedText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.completedPrimaryButtonLabel",
            "fieldCode": "content.completedPrimaryButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.completedSecondaryButtonLabel",
            "fieldCode": "content.completedSecondaryButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemCheckoutSteps.changeDeliveryPaymentButtonLabel",
            "fieldCode": "content.changeDeliveryPaymentButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemAccountNavigation": [
        {
            "defaultMessageKey": "block.systemAccountNavigation.overviewTitle",
            "fieldCode": "content.overviewTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.ordersCardTitle",
            "fieldCode": "content.ordersCardTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.ordersCardButtonLabel",
            "fieldCode": "content.ordersCardButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.profileTitle",
            "fieldCode": "content.profileTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.logoutButtonLabel",
            "fieldCode": "content.logoutButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.favoriteViewButtonLabel",
            "fieldCode": "content.favoriteViewButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.eyebrow",
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.text",
            "fieldCode": "content.text",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.benefit1Text",
            "fieldCode": "content.benefit1Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.benefit2Text",
            "fieldCode": "content.benefit2Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.benefit3Text",
            "fieldCode": "content.benefit3Text",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.overviewEyebrow",
            "fieldCode": "content.overviewEyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.profileButtonLabel",
            "fieldCode": "content.profileButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.activityEyebrow",
            "fieldCode": "content.activityEyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.activityTitle",
            "fieldCode": "content.activityTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.addressSaveButtonLabel",
            "fieldCode": "content.addressSaveButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.firstnameInput",
            "fieldCode": "content.firstnameInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.lastnameInput",
            "fieldCode": "content.lastnameInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.companyInput",
            "fieldCode": "content.companyInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.icInput",
            "fieldCode": "content.icInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.vatInput",
            "fieldCode": "content.vatInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.addressTitle",
            "fieldCode": "content.addressTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.address1Input",
            "fieldCode": "content.address1Input",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.houseNumberInput",
            "fieldCode": "content.houseNumberInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.postcodeInput",
            "fieldCode": "content.postcodeInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.cityInput",
            "fieldCode": "content.cityInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.emailInput",
            "fieldCode": "content.emailInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.phoneInput",
            "fieldCode": "content.phoneInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.address2Input",
            "fieldCode": "content.address2Input",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.profileText",
            "fieldCode": "content.profileText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.profileSaveButtonLabel",
            "fieldCode": "content.profileSaveButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.passwordTitle",
            "fieldCode": "content.passwordTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.passwordText",
            "fieldCode": "content.passwordText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.passwordSaveButtonLabel",
            "fieldCode": "content.passwordSaveButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.currentPasswordInput",
            "fieldCode": "content.currentPasswordInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.newPasswordInput",
            "fieldCode": "content.newPasswordInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.newPasswordConfirmationInput",
            "fieldCode": "content.newPasswordConfirmationInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.favoriteRemoveButtonLabel",
            "fieldCode": "content.favoriteRemoveButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.resetTitle",
            "fieldCode": "content.resetTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.resetText",
            "fieldCode": "content.resetText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.resetEmailInput",
            "fieldCode": "content.resetEmailInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.resetBackButtonLabel",
            "fieldCode": "content.resetBackButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.resetSubmitButtonLabel",
            "fieldCode": "content.resetSubmitButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.newPasswordTitle",
            "fieldCode": "content.newPasswordTitle",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.newPasswordText",
            "fieldCode": "content.newPasswordText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.newPasswordSubmitButtonLabel",
            "fieldCode": "content.newPasswordSubmitButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.passwordInput",
            "fieldCode": "content.passwordInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.passwordConfirmationInput",
            "fieldCode": "content.passwordConfirmationInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.forgotPasswordButtonLabel",
            "fieldCode": "content.forgotPasswordButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.newsletterOptOutText",
            "fieldCode": "content.newsletterOptOutText",
            "format": "richText",
            "localizable": true,
            "multiline": true
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.submitLoginButtonLabel",
            "fieldCode": "content.submitLoginButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemAccountNavigation.submitRegisterButtonLabel",
            "fieldCode": "content.submitRegisterButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemContactForm": [
        {
            "defaultMessageKey": "block.systemContactForm.eyebrow",
            "fieldCode": "content.eyebrow",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemContactForm.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemContactForm.nameInput",
            "fieldCode": "content.nameInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemContactForm.emailInput",
            "fieldCode": "content.emailInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemContactForm.messageInput",
            "fieldCode": "content.messageInput",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemContactForm.submitButtonLabel",
            "fieldCode": "content.submitButtonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemContactForm.successMessage",
            "fieldCode": "content.successMessage",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemContactForm.buttonLabel",
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ],
    "systemSearchForm": [
        {
            "defaultMessageKey": "block.systemSearchForm.title",
            "fieldCode": "content.title",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSearchForm.placeholder",
            "fieldCode": "content.placeholder",
            "format": "plainText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSearchForm.buttonLabel",
            "fieldCode": "content.buttonLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSearchForm.emptyText",
            "fieldCode": "content.emptyText",
            "format": "richText",
            "localizable": true,
            "multiline": false
        },
        {
            "defaultMessageKey": "block.systemSearchForm.searchLabel",
            "fieldCode": "content.searchLabel",
            "format": "richText",
            "localizable": true,
            "multiline": false
        }
    ]
});
